import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-solid-svg-icons';
import type { ReactNode } from 'react';
import { SCView } from '../view';

function SCLoading({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <SCView flex justifyCenter gap={2} itemsCenter p={2} className={className} style={style}>
      <FontAwesomeIcon icon={faSpinnerThird} spin />
      Loading...
    </SCView>
  );
}

function SCError({
  title = 'Error',
  message,
  className,
  style,
  children,
}: {
  title?: string;
  message?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: ReactNode;
}) {
  return (
    <SCView
      flex
      flexCol
      justifyCenter
      itemsCenter
      gap={2}
      p={2}
      className={className}
      style={style}
    >
      <SCView textXl mr={2}>
        {title}
      </SCView>
      {message ? <div>{message}</div> : null}
      <SCView mt={4}>{children}</SCView>
    </SCView>
  );
}

export { SCError, SCLoading };
